import * as Sentry from '@sentry/react';
import React, { useEffect, useMemo, useState , useRef } from "react";
import { useDispatch } from "react-redux";

import COLOR from "utils/constants/color";
import SpinLoader from "components/Loader/SpinLoader";
import styled from "styled-components";
import { DeleteModal } from "components/Dialog";
import { cloneDeep, map } from "lodash";
import { handleDeleteGrammarContent, handleUpdateGrammarContent } from "store/page_translations/thunks";
import { Row , Col, message } from "antd";
import { usePageGrammarContent } from "store/page_translations/selectors";

import {
    Button,
    FormControl,
    FormHelperText,
    IconButton,
    InputLabel,
    TextField,
   
    TextareaAutosize,
    Modal,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
    Add,
    CheckCircle,
    Close,
    Delete,
    MenuBook
} from '@mui/icons-material';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import BadgeButton from '../BadgeButton';












const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 200px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: auto;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    // margin-left:5px;
    // margin-top:5px;
`;
const CustomFormHelperText = styled(FormHelperText)`
 color:red !important;
  .MuiFormHelperText-root{
  color:red !important;
  }
`

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: '4px',
    },
  }));
const GrammarContentToolBar = ({ bookId, pageId, hasPermission = true }) => {
    const showAlert = useAlert()
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false)
    const classes = useStyles();
        const scrollRef = useRef();
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState(false);
    const [page_contents, setPageContents] = useState([])
    const { book_grammar_content } = usePageGrammarContent()
    const [content, setContent] = useState([])
    const has_page_content = useMemo(() => page_contents.find((page_content) => page_content.page == pageId), [page_contents, pageId])
    useEffect(() => {
        if (has_page_content) {
            setContent(has_page_content?.content)
        } else {
            setContent([])
        }
    }, [has_page_content])
    useEffect(() => {
        if (book_grammar_content) {
            setPageContents(book_grammar_content)
        } else {
            setPageContents([])
        }
    }, [book_grammar_content, bookId])

    const addGrammarContent = () => {
        const h = cloneDeep(content);
        h.push({
            title: "",
            prompt: ""
        });
        setContent(h);
        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
            }
        }, 500);
    };
    const removeGrammarContent = (index) => {
        const h = cloneDeep(content);
        h.splice(index, 1);
        setContent(h);
        setError(false);
    };

    const onUpdate = async ({ }) => {
       const has_all_filed = content.every((c) => c.title && c.prompt)
       if(!has_all_filed){
        setError('All fields are required')
        return 
       }
        setLoading(true)
        try {
            await dispatch(handleUpdateGrammarContent({
                id: has_page_content?.id,
                chapter: bookId,
                page: pageId,
                content
            }))
            showAlert("AI Grammar content updated successfully ✅", 'success')
            setOpenModal(false)
        } catch (error) {
            Sentry.captureException(`295 Error in grammar content update: ${error}`);
            showAlert("Something went wrong!", 'error')
        } finally {
            setLoading(false)
            setError(false);
        }
    }
    const onDelete = async () => {
        setDeleteLoader(true)
        try {
            const dt = await dispatch(handleDeleteGrammarContent(has_page_content?.id));
            if(dt&&dt.success) {
                showAlert(`AI Grammar content removed successfully`, 'success')
                setOpenModal(false)
            }else{
                showAlert("Something went wrong!", 'error')
            } 
        } catch (error) {
            Sentry.captureException(`296 Error in grammar content delete: ${error}`);
            console.log(error,"error in grammar content remove.")
        } finally {
            setDeleteLoader(false)
            setDeleteModal(false)
        }
        
      
    }
    const onClose = () => {
        setOpenModal(false)
    }
    const onChnageContent = (index, key, value) => {
        const h = cloneDeep(content);
        if (h[index]) {
            h[index][key] = value;
            setContent(h)
            setError(false);
        }else{
            setError("Something went wrong!")
        }

    };
    return (<>
        <BadgeButton
            onClick={() => {
                if (!hasPermission) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                }
                setOpenModal(true);
            }}
            startIcon={<MenuBook />}
            showBadge={has_page_content}
            backgroundColor="#8b5cf6"
        >
            Grammar AI Activity
        </BadgeButton>
        <SpinLoader dataloader={loading} />
        <DeleteModal
            deleteToggle={deleteModal}
            loading={deleteLoader}
            onDelete={onDelete}
            setDeleteToggle={setDeleteModal}
            message={`Are you sure you want to remove the Grammar AI content on pageId ${pageId}?`} />
        <Modal
            open={openModal}
            onClose={onClose}
            style={{ height: "100%", width: "100%" }}
        >
            <ModalContent style={{ width: "60vw" }}>
                <Row style={{ justifyContent: "space-between" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Add />}
                        onClick={addGrammarContent}
                        style={{ marginTop: 10 }}
                    >
                        Add prompt
                    </Button>
                    {has_page_content ? <IconButton
                        onClick={() => {
                            setDeleteModal(true)
                        }}
                        style={{ padding: 0 }}
                    >
                        <Delete color="secondary" />
                    </IconButton> : null}
                    <IconButton
                        onClick={() => onClose()}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <ModalConfigArea ref={scrollRef}>
                    {map(content, ({ title , prompt }, i) => (
                        <LinkArea key={i}>
                            <Row
                                gutter={[24, 24]}
                                style={{ justifyContent: "flex-end", display: "flex" }}
                            >
                                {content.length == 1 ? null : <IconButton
                                    onClick={() => removeGrammarContent(i)}
                                    style={{ padding: 0, marginRight: 10 }}
                                >
                                    <Delete color="secondary" />
                                </IconButton>}
                            </Row>
                            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                                <Col span={24}>
                                    <TextField
                                        id="title"
                                        name="title"
                                        label="Title"
                                        InputLabelProps={{ shrink: true }}
                                        type="text"
                                        variant="outlined"
                                        onChange={(e) => {
                                            onChnageContent(i, "title", e.target.value);
                                        }}
                                        value={title}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                                <Col span={24}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="textTip" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>AI Prompt</InputLabel>
                                        <TextAreaAuto
                                            id="prompt"
                                            type="text"
                                            minRows={3}
                                            maxRows={5}
                                            variant="outlined"
                                            onChange={(e) => {
                                                 onChnageContent(i, "prompt", e.target.value);
                                            }}
                                            value={prompt}
                                        />
                                    </FormControl>
                                </Col>
                            </Row>
                        </LinkArea>
                    ))}
                </ModalConfigArea>
                {error ? (
                    <CustomFormHelperText>
                        All fields are required , Please fill it or remove it.
                    </CustomFormHelperText>
                ) : null}
                <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
                >
                    <Button
                        fullWidth
                        onClick={onUpdate}
                        disabled={content.length ===0}
                        color="primary"
                        variant="contained"
                    >
                        Update
                    </Button>
                </Row>
            </ModalContent>
        </Modal>
    </>)
}

export default GrammarContentToolBar;